<template>
  <div v-if="total > 0" class="d-flex justify-content-between align-items-center flex-wrap gap-2 pagination-barre">
    <small class="text-muted">
      {{ debut }}–{{ fin }} sur {{ total.toLocaleString('fr-FR') }}
    </small>
    <div class="d-flex align-items-center gap-2">
      <select class="form-select form-select-sm w-auto" :value="parPage" aria-label="Lignes par page" @change="$emit('update:parPage', +$event.target.value); $emit('update:page', 1)">
        <option v-for="n in tailles" :key="n" :value="n">{{ n }} / page</option>
      </select>
      <nav aria-label="Pages">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: page <= 1 }">
            <button class="page-link" :disabled="page <= 1" aria-label="Page précédente" @click="aller(page - 1)">‹</button>
          </li>
          <li v-for="p in pagesVisibles" :key="p.cle" class="page-item" :class="{ active: p.numero === page, disabled: !p.numero }">
            <button class="page-link" :disabled="!p.numero" @click="p.numero && aller(p.numero)">{{ p.numero || '…' }}</button>
          </li>
          <li class="page-item" :class="{ disabled: page >= pages }">
            <button class="page-link" :disabled="page >= pages" aria-label="Page suivante" @click="aller(page + 1)">›</button>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
/**
 * Pagination commune (côté serveur) : v-model:page et v-model:parPage,
 * « total » = nombre total de lignes renvoyé par l'API (meta.total_records).
 */
export default {
  name: 'Pagination',
  props: {
    page: { type: Number, default: 1 },
    parPage: { type: Number, default: 25 },
    total: { type: Number, default: 0 },
    tailles: { type: Array, default: () => [10, 25, 50, 100] },
  },
  emits: ['update:page', 'update:parPage'],
  computed: {
    pages() { return Math.max(1, Math.ceil(this.total / this.parPage)) },
    debut() { return this.total ? (this.page - 1) * this.parPage + 1 : 0 },
    fin() { return Math.min(this.total, this.page * this.parPage) },
    pagesVisibles() {
      const n = this.pages
      const p = this.page
      const set = new Set([1, n, p - 1, p, p + 1].filter(x => x >= 1 && x <= n))
      const tri = [...set].sort((a, b) => a - b)
      const r = []
      tri.forEach((x, i) => {
        if (i && x - tri[i - 1] > 1) r.push({ cle: 'e' + x, numero: null })
        r.push({ cle: x, numero: x })
      })
      return r
    },
  },
  methods: {
    aller(n) {
      if (n >= 1 && n <= this.pages && n !== this.page) this.$emit('update:page', n)
    },
  },
}
</script>

<style scoped>
.pagination-barre { padding: 10px 4px 0; }
</style>
